import {ChevronDown} from 'lucide-react';
import {cn} from '../lib/cn';

type RotateArrowProps = {
  shouldRotate?: boolean;
  className?: string;
};

function RotateArrow({shouldRotate, className}: RotateArrowProps) {
  return (
    <ChevronDown
      size={16}
      className={cn(
        `rotate-arrow pointer-events-none relative cursor-pointer select-none rounded
         transition-transform`,
        shouldRotate && 'rotate-180',
        className,
      )}
    />
  );
}

export {RotateArrow};
export type {RotateArrowProps};
